import { BaseResponse } from "api/models/infrastructure";
import { JobsCriteria, JobsResponse, ReprocessJobRequest, ResetQueueRequest } from "api/models/queues";
import api from "api/utils";


const baseUrl = "api/queues";

const getJobs = async (criteria?: JobsCriteria) => {
    return api.query<JobsCriteria, JobsResponse>({
        baseUrl: baseUrl,
        queryParams: criteria
    });
};

const resetQueue = async (request: ResetQueueRequest) => {
    return api.command<ResetQueueRequest, BaseResponse>({
        baseUrl: baseUrl,
        body: request,
        method: "POST"
    });
};

const reprocessJob = async (request: ReprocessJobRequest) => {
    return api.command<ReprocessJobRequest, BaseResponse>({
        baseUrl: `${baseUrl}/reprocess`,
        body: request,
        method: "POST"
    });
};

const queuesService = {
    getJobs,
    resetQueue,
    reprocessJob
};

export default queuesService;